/**
 * Web Search Provider Constants
 */

import type { WebSearchProviderId, WebSearchProviderConfig } from './types';

/**
 * Web Search Provider Registry
 *
 * dongniai vendor note 2026-07-10: OpenMAIC official a2886af9 adds brave / baidu / bocha / doubao
 * providers. Inserted additively below — existing tavily/minimax unchanged.
 */
export const WEB_SEARCH_PROVIDERS: Record<WebSearchProviderId, WebSearchProviderConfig> = {
  tavily: {
    id: 'tavily',
    name: 'Tavily',
    requiresApiKey: true,
    defaultBaseUrl: 'https://api.tavily.com',
  },
  minimax: {
    id: 'minimax',
    name: 'MiniMax',
    requiresApiKey: false, // server-configured via backend admin panel
    defaultBaseUrl: 'https://api.minimaxi.com/v1',
  },
  brave: {
    id: 'brave',
    name: 'Brave',
    requiresApiKey: true,
    defaultBaseUrl: 'https://api.search.brave.com/res/v1/web/search',
  },
  baidu: {
    id: 'baidu',
    name: '百度',
    requiresApiKey: true,
    defaultBaseUrl: 'https://qianfan.baidubce.com',
  },
  bocha: {
    id: 'bocha',
    name: '博查',
    requiresApiKey: true,
    defaultBaseUrl: 'https://api.bochaai.com/v1/web-search',
  },
  doubao: {
    id: 'doubao',
    name: '豆包',
    requiresApiKey: true,
    defaultBaseUrl: 'https://ark.cn-beijing.volces.com/api/v3',
  },
};

/**
 * Get all available web search providers
 */
export function getAllWebSearchProviders(): WebSearchProviderConfig[] {
  return Object.values(WEB_SEARCH_PROVIDERS);
}
